/** IMPORTANT: This file is auto-generated by eddev. Do not edit. */
import { blockManifestReader } from "eddev/_internal";
import { dynamic } from "eddev/dynamic";
import core from "../../../blocks/_core";

const manifest = {
  "acf/content-accordion": dynamic(
    () => import("../../../blocks/content/accordion.tsx"),
    "blocks/content/accordion.tsx",
  ),
  "acf/content-accordion-group": dynamic(
    () => import("../../../blocks/content/accordion-group.tsx"),
    "blocks/content/accordion-group.tsx",
  ),
  "acf/content-anchor": dynamic(() => import("../../../blocks/content/anchor.tsx"), "blocks/content/anchor.tsx"),
  "acf/content-awards": dynamic(() => import("../../../blocks/content/awards.tsx"), "blocks/content/awards.tsx"),
  "acf/content-awards-item": dynamic(
    () => import("../../../blocks/content/awards-item.tsx"),
    "blocks/content/awards-item.tsx",
  ),
  "acf/content-big-text": dynamic(() => import("../../../blocks/content/big-text.tsx"), "blocks/content/big-text.tsx"),
  "acf/content-carousel-header": dynamic(
    () => import("../../../blocks/content/carousel-header.tsx"),
    "blocks/content/carousel-header.tsx",
  ),
  "acf/content-contact-form": dynamic(
    () => import("../../../blocks/content/contact-form.tsx"),
    "blocks/content/contact-form.tsx",
  ),
  "acf/content-divider": dynamic(() => import("../../../blocks/content/divider.tsx"), "blocks/content/divider.tsx"),
  "acf/content-featured-journal": dynamic(
    () => import("../../../blocks/content/featured-journal.tsx"),
    "blocks/content/featured-journal.tsx",
  ),
  "acf/content-generic-page-header": dynamic(
    () => import("../../../blocks/content/generic-page-header.tsx"),
    "blocks/content/generic-page-header.tsx",
  ),
  "acf/content-image-gallery": dynamic(
    () => import("../../../blocks/content/image-gallery.tsx"),
    "blocks/content/image-gallery.tsx",
  ),
  "acf/content-inline-media": dynamic(
    () => import("../../../blocks/content/inline-media.tsx"),
    "blocks/content/inline-media.tsx",
  ),
  "acf/content-inline-media-item": dynamic(
    () => import("../../../blocks/content/inline-media-item.tsx"),
    "blocks/content/inline-media-item.tsx",
  ),
  "acf/content-intro-copy": dynamic(
    () => import("../../../blocks/content/intro-copy.tsx"),
    "blocks/content/intro-copy.tsx",
  ),
  "acf/content-intro-copy-button": dynamic(
    () => import("../../../blocks/content/intro-copy-button.tsx"),
    "blocks/content/intro-copy-button.tsx",
  ),
  "acf/content-intro-copy-left": dynamic(
    () => import("../../../blocks/content/intro-copy-left.tsx"),
    "blocks/content/intro-copy-left.tsx",
  ),
  "acf/content-intro-copy-left-button": dynamic(
    () => import("../../../blocks/content/intro-copy-left-button.tsx"),
    "blocks/content/intro-copy-left-button.tsx",
  ),
  "acf/content-intro-copy-right": dynamic(
    () => import("../../../blocks/content/intro-copy-right.tsx"),
    "blocks/content/intro-copy-right.tsx",
  ),
  "acf/content-job-list": dynamic(() => import("../../../blocks/content/job-list.tsx"), "blocks/content/job-list.tsx"),
  "acf/content-journal-header": dynamic(
    () => import("../../../blocks/content/journal-header.tsx"),
    "blocks/content/journal-header.tsx",
  ),
  "acf/content-journals-grid": dynamic(
    () => import("../../../blocks/content/journals-grid.tsx"),
    "blocks/content/journals-grid.tsx",
  ),
  "acf/content-journals-list": dynamic(
    () => import("../../../blocks/content/journals-list.tsx"),
    "blocks/content/journals-list.tsx",
  ),
  "acf/content-landing-intro": dynamic(
    () => import("../../../blocks/content/landing-intro.tsx"),
    "blocks/content/landing-intro.tsx",
  ),
  "acf/content-large-list": dynamic(
    () => import("../../../blocks/content/large-list.tsx"),
    "blocks/content/large-list.tsx",
  ),
  "acf/content-narrow-content": dynamic(
    () => import("../../../blocks/content/narrow-content.tsx"),
    "blocks/content/narrow-content.tsx",
  ),
  "acf/content-newsletter-subscribe": dynamic(
    () => import("../../../blocks/content/newsletter-subscribe.tsx"),
    "blocks/content/newsletter-subscribe.tsx",
  ),
  "acf/content-people-list": dynamic(
    () => import("../../../blocks/content/people-list.tsx"),
    "blocks/content/people-list.tsx",
  ),
  "acf/content-project-credits": dynamic(
    () => import("../../../blocks/content/project-credits.tsx"),
    "blocks/content/project-credits.tsx",
  ),
  "acf/content-project-grid": dynamic(
    () => import("../../../blocks/content/project-grid.tsx"),
    "blocks/content/project-grid.tsx",
  ),
  "acf/content-project-header": dynamic(
    () => import("../../../blocks/content/project-header.tsx"),
    "blocks/content/project-header.tsx",
  ),
  "acf/content-project-list": dynamic(
    () => import("../../../blocks/content/project-list.tsx"),
    "blocks/content/project-list.tsx",
  ),
  "acf/content-project-marquee": dynamic(
    () => import("../../../blocks/content/project-marquee.tsx"),
    "blocks/content/project-marquee.tsx",
  ),
  "acf/content-related-journals": dynamic(
    () => import("../../../blocks/content/related-journals.tsx"),
    "blocks/content/related-journals.tsx",
  ),
  "acf/content-related-projects": dynamic(
    () => import("../../../blocks/content/related-projects.tsx"),
    "blocks/content/related-projects.tsx",
  ),
  "acf/content-scrolling-carousel": dynamic(
    () => import("../../../blocks/content/scrolling-carousel.tsx"),
    "blocks/content/scrolling-carousel.tsx",
  ),
  "acf/content-search-grid": dynamic(
    () => import("../../../blocks/content/search-grid.tsx"),
    "blocks/content/search-grid.tsx",
  ),
  "acf/content-search-header": dynamic(
    () => import("../../../blocks/content/search-header.tsx"),
    "blocks/content/search-header.tsx",
  ),
  "acf/content-small-list": dynamic(
    () => import("../../../blocks/content/small-list.tsx"),
    "blocks/content/small-list.tsx",
  ),
  "acf/content-stats": dynamic(() => import("../../../blocks/content/stats.tsx"), "blocks/content/stats.tsx"),
  "acf/content-stats-item": dynamic(
    () => import("../../../blocks/content/stats-item.tsx"),
    "blocks/content/stats-item.tsx",
  ),
  "acf/content-studios-list": dynamic(
    () => import("../../../blocks/content/studios-list.tsx"),
    "blocks/content/studios-list.tsx",
  ),
  "acf/content-testimonial": dynamic(
    () => import("../../../blocks/content/testimonial.tsx"),
    "blocks/content/testimonial.tsx",
  ),
  "acf/content-text-cta": dynamic(() => import("../../../blocks/content/text-cta.tsx"), "blocks/content/text-cta.tsx"),
  "acf/content-topic-list": dynamic(
    () => import("../../../blocks/content/topic-list.tsx"),
    "blocks/content/topic-list.tsx",
  ),
  "acf/content-topic-list-item": dynamic(
    () => import("../../../blocks/content/topic-list-item.tsx"),
    "blocks/content/topic-list-item.tsx",
  ),
  ...core,
};

const info = {
  "acf/content-accordion": { "slug": "content/accordion", "flags": {} },
  "acf/content-accordion-group": { "slug": "content/accordion-group", "flags": {} },
  "acf/content-anchor": { "slug": "content/anchor", "flags": {} },
  "acf/content-awards": { "slug": "content/awards", "tags": ["#page"], "flags": {} },
  "acf/content-awards-item": { "slug": "content/awards-item", "flags": {} },
  "acf/content-big-text": { "slug": "content/big-text", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-carousel-header": { "slug": "content/carousel-header", "tags": ["#page"], "flags": {} },
  "acf/content-contact-form": { "slug": "content/contact-form", "tags": ["#page"], "flags": {} },
  "acf/content-divider": { "slug": "content/divider", "tags": ["#page"], "flags": {} },
  "acf/content-featured-journal": { "slug": "content/featured-journal", "tags": ["#page"], "flags": {} },
  "acf/content-generic-page-header": { "slug": "content/generic-page-header", "tags": ["#page"], "flags": {} },
  "acf/content-image-gallery": { "slug": "content/image-gallery", "tags": ["#page"], "flags": {} },
  "acf/content-inline-media": { "slug": "content/inline-media", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-inline-media-item": { "slug": "content/inline-media-item", "flags": {} },
  "acf/content-intro-copy": { "slug": "content/intro-copy", "tags": ["#page"], "flags": {} },
  "acf/content-intro-copy-button": { "slug": "content/intro-copy-button", "tags": ["#page"], "flags": {} },
  "acf/content-intro-copy-left": { "slug": "content/intro-copy-left", "flags": {} },
  "acf/content-intro-copy-left-button": { "slug": "content/intro-copy-left-button", "flags": {} },
  "acf/content-intro-copy-right": { "slug": "content/intro-copy-right", "flags": {} },
  "acf/content-job-list": { "slug": "content/job-list", "tags": ["#page"], "flags": {} },
  "acf/content-journal-header": { "slug": "content/journal-header", "tags": ["#page"], "flags": {} },
  "acf/content-journals-grid": { "slug": "content/journals-grid", "tags": ["#page"], "flags": {} },
  "acf/content-journals-list": { "slug": "content/journals-list", "tags": ["#page"], "flags": {} },
  "acf/content-landing-intro": { "slug": "content/landing-intro", "tags": ["#page"], "flags": {} },
  "acf/content-large-list": { "slug": "content/large-list", "tags": ["#page"], "flags": {} },
  "acf/content-narrow-content": { "slug": "content/narrow-content", "tags": ["#page"], "flags": {} },
  "acf/content-newsletter-subscribe": { "slug": "content/newsletter-subscribe", "tags": ["#page"], "flags": {} },
  "acf/content-people-list": { "slug": "content/people-list", "tags": ["#page"], "flags": {} },
  "acf/content-project-credits": { "slug": "content/project-credits", "tags": ["#page"], "flags": {} },
  "acf/content-project-grid": { "slug": "content/project-grid", "tags": ["#page"], "flags": {} },
  "acf/content-project-header": { "slug": "content/project-header", "tags": ["#page"], "flags": {} },
  "acf/content-project-list": { "slug": "content/project-list", "tags": ["#page"], "flags": {} },
  "acf/content-project-marquee": { "slug": "content/project-marquee", "tags": ["#page"], "flags": {} },
  "acf/content-related-journals": { "slug": "content/related-journals", "tags": ["#page"], "flags": {} },
  "acf/content-related-projects": { "slug": "content/related-projects", "tags": ["#page"], "flags": {} },
  "acf/content-scrolling-carousel": { "slug": "content/scrolling-carousel", "tags": ["#page"], "flags": {} },
  "acf/content-search-grid": { "slug": "content/search-grid", "tags": ["#page"], "flags": {} },
  "acf/content-search-header": { "slug": "content/search-header", "tags": ["#page"], "flags": {} },
  "acf/content-small-list": { "slug": "content/small-list", "tags": ["#page"], "flags": {} },
  "acf/content-stats": { "slug": "content/stats", "tags": ["#page"], "flags": {} },
  "acf/content-stats-item": { "slug": "content/stats-item", "flags": {} },
  "acf/content-studios-list": { "slug": "content/studios-list", "tags": ["#page"], "flags": {} },
  "acf/content-testimonial": { "slug": "content/testimonial", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-text-cta": { "slug": "content/text-cta", "tags": ["#page", "#inline"], "flags": {} },
  "acf/content-topic-list": { "slug": "content/topic-list", "tags": ["#page"], "flags": {} },
  "acf/content-topic-list-item": { "slug": "content/topic-list-item", "flags": {} },
};

blockManifestReader.set(manifest, info);

export default manifest;

if (import.meta.hot) {
  import.meta.hot.accept();
}
